import React, { PureComponent } from 'react';
import { Col, Container, Row } from 'reactstrap';
import SbCampaignsGrid from './components/SbCampaignsGrid';

class SbCampaignsPage extends PureComponent {
  render() {
    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">Amazon Sponsored Brand Campaigns</h3>
            <h3 className="page-subhead subhead">Selected Account Data</h3>
          </Col>
        </Row>
        <Row>
          <SbCampaignsGrid />
        </Row>
      </Container>
    );
  }
}

export default SbCampaignsPage;
